import React from 'react';
import PropTypes from 'prop-types';
import NumberInput from './NumberInput';
import TimeInput from './TimeInput';

const CompoundDaysTimeInput = ({
  wholeDays,
  remainderMinutes,
  onChange,
  disabled,
  id,
  allowNegative,
  isNegative,
  onSignChange,
  showLabels,
  daysLabel,
  hoursLabel,
}) => {
  const handleDaysChange = days => {
    onChange({ wholeDays: days ?? 0, remainderMinutes: remainderMinutes ?? 0 });
  };

  const handleMinutesChange = minutes => {
    onChange({ wholeDays: wholeDays ?? 0, remainderMinutes: minutes ?? 0 });
  };

  return (
    <div className="compound-days-time-input">
      {showLabels && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
          {allowNegative && <div style={{ minWidth: '30px' }} />}
          <div style={{ width: '70px' }}>
            <small className="text-muted">{daysLabel}</small>
          </div>
          <div style={{ width: '110px' }}>
            <small className="text-muted">{hoursLabel}</small>
          </div>
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {allowNegative && (
          <button
            type="button"
            className="btn btn-default btn-sm"
            disabled={disabled}
            onClick={() => onSignChange(!isNegative)}
            style={{ minWidth: '30px' }}
          >
            {isNegative ? '−' : '+'}
          </button>
        )}
        <div style={{ width: '70px' }}>
          <NumberInput
            id={`${id}-days`}
            value={wholeDays ?? 0}
            onChange={handleDaysChange}
            min={0}
            step={0.5}
            disabled={disabled}
          />
        </div>
        <div style={{ width: '140px' }}>
          <TimeInput
            id={`${id}-time`}
            value={remainderMinutes ?? 0}
            onChange={handleMinutesChange}
            min={0}
            max={59999}
            disabled={disabled}
            padHours={false}
          />
        </div>
      </div>
    </div>
  );
};

CompoundDaysTimeInput.propTypes = {
  wholeDays: PropTypes.number,
  remainderMinutes: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  allowNegative: PropTypes.bool,
  isNegative: PropTypes.bool,
  onSignChange: PropTypes.func,
  showLabels: PropTypes.bool,
  daysLabel: PropTypes.string,
  hoursLabel: PropTypes.string,
};

CompoundDaysTimeInput.defaultProps = {
  wholeDays: 0,
  remainderMinutes: 0,
  disabled: false,
  id: 'CompoundDaysTimeInput',
  allowNegative: false,
  isNegative: false,
  onSignChange: () => {},
  showLabels: false,
  daysLabel: 'Days',
  hoursLabel: 'Hours',
};

export default CompoundDaysTimeInput;
